import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_MONITOR_APPLICATIONS,
  GET_AZURE_MONITOR_APPLICATIONS_SUCCESS,
  GET_AZURE_MONITOR_APPLICATIONS_ERROR,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS_SUCCESS,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS_ERROR,
} from "./constant";

const initialStateApplication = {
  phase: INIT,
  azureMonitorApplicationsList: null,
  error: null,
};

const initialStateApplicationParams = {
  phase2: INIT,
  azureMonitorApplicationsParamsList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureMonitorApplicationsStore(
  state = initialStateApplication,
  action
) {
  switch (action.type) {
    case GET_AZURE_MONITOR_APPLICATIONS:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_MONITOR_APPLICATIONS_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureMonitorApplicationsList: action.data,
        error: null,
      };
    case GET_AZURE_MONITOR_APPLICATIONS_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}

export function AzureMonitorApplicationsParamsStore(
  state = initialStateApplicationParams,
  action
) {
  switch (action.type) {
    case GET_AZURE_MONITOR_APPLICATIONS_PARAMS:
      return {
        ...state,
        phase2: LOADING,
      };
    case GET_AZURE_MONITOR_APPLICATIONS_PARAMS_SUCCESS:
      return {
        ...state,
        phase2: SUCCESS,
        azureMonitorApplicationsParamsList: action.data,
        error: null,
      };
    case GET_AZURE_MONITOR_APPLICATIONS_PARAMS_ERROR:
      return { ...state, phase2: ERROR, error: action.error };

    default:
      return state;
  }
}
